// export const KentrixFiltersDescription = [
//   {
//     "Group": "Socio-Economic Profile",
//     "Category": "Income",
//     "SubCategory": "01: INR <40,000",
//     "Description(Facebook)": "Consumer is living in an urban area, where the monthly household-level income is typically 01: INR <40,000",
//     "OneLiner": "Househole Income is below 40,000 Rs/Month",
//     "PopUpInfoIconDescription": "Consumer is living in an urban area, where the monthly household-level income is typically Medium (INR 40,000 - 80,000).",
//     "FilterDescription": "Demographic information such as Affluence and income are provided in these segments.",
//     "ID": 1
//   },
//   {
//     "Group": "Socio-Economic Profile",
//     "Category": "Income",
//     "SubCategory": "02: INR 40,000 - 80,000",
//     "Description(Facebook)": "Consumer is living in an urban area, where the monthly household-level income is typically 02: INR 40,000 - 80,000",
//     "OneLiner": "Househole Income is between 40,000 to 80,000 Rs/Month",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 2
//   },
//   {
//     "Group": "Socio-Economic Profile",
//     "Category": "Income",
//     "SubCategory": "03: INR 80,000 - 1,70,000",
//     "Description(Facebook)": "Consumer is living in an urban area, where the monthly household-level income is typically 03: INR 80,000 - 1,70,000",
//     "OneLiner": "Househole Income is between 80,000 to 1,70,000 Rs/Month",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 3
//   },
//   {
//     "Group": "Socio-Economic Profile",
//     "Category": "Income",
//     "SubCategory": "04: INR 1,70,000 - 3,00,000",
//     "Description(Facebook)": "Consumer is living in an urban area, where the monthly household-level income is typically 04: INR 1,70,000 - 3,00,000",
//     "OneLiner": "Househole Income is between 1,70,000 to 3,00,000 Rs/Month",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 4
//   },
//   {
//     "Group": "Socio-Economic Profile",
//     "Category": "Income",
//     "SubCategory": "05: INR >3,00,000",
//     "Description(Facebook)": "Consumer is living in an urban area, where the monthly household-level income is typically 05: INR >3,00,000",
//     "OneLiner": "Househole Income is greater 3,00,000 Rs/Month",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 5
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "Lifestyle",
//     "SubCategory": "01: Urban Established Elite",
//     "Description(Facebook)": "“The world is our playground”. Wealthy, educated families. Attended (inter)national leading educational institutes. Accustomed to international luxury and quality standards. Global mind-set. Sophisticated orientations in style and taste. Self-confident. Individual, liberal attitudes. Financially secure. Highly brand conscious. Shop for status, not for price. Memberships in selected Private Clubs. Outdoor dining, exquisite restaurants.",
//     "OneLiner": "“The world is our playground”. Wealthy, educated families.",
//     "PopUpInfoIconDescription": "Attended (inter)national leading educational institutes. Accustomed to international luxury and quality standards. Global mind-set. Sophisticated orientations in style and taste. Self-confident. Individual, liberal attitudes. Financially secure. Highly brand conscious. Shop for status, not for price. Memberships in selected Private Clubs. Outdoor dining, exquisite restaurants.",
//     "FilterDescription": "Segments the population into different categories based on demographic information and consumption habits like consumption and social status.",
//     "ID": 6
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "Lifestyle",
//     "SubCategory": "02: Urban New Wealth",
//     "Description(Facebook)": "“We are the new cosmopolitan leaders”. Newly arrived, status conscious Upper Class. Having gained their professional platform and recognition based upon their high-level education. Ambitious, convinced in their own strength. Developing international perspectives. Striving for the exquisite taste. Easy to be led in search for top class quality and comfort standards. Memberships in Private Clubs. Outdoor dining, high class restaurants.",
//     "OneLiner": "“We are the new cosmopolitan leaders”. Newly arrived, status conscious Upper Class.",
//     "PopUpInfoIconDescription": "Having gained their professional platform and recognition based upon their high-level education. Ambitious, convinced in their own strength. Developing international perspectives. Striving for the exquisite taste. Easy to be led in search for top class quality and comfort standards. Memberships in Private Clubs. Outdoor dining, high class restaurants.",
//     "FilterDescription": "",
//     "ID": 7
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "Lifestyle",
//     "SubCategory": "03: Aspiring Urban Middle Class",
//     "Description(Facebook)": "“We are here and want it now”. Aspiring Middle Class. Value seekers. Educational background: University degrees, dominant. Benchmarking with the next above. Desire a predictable life. Spending mid-range budgets on consumer goods and leisure time activities. Want to buy cheap, but not feel cheap. Ready to change for a new attractive offer. Younger members spend and indulge in their present wellbeing.",
//     "OneLiner": "“We are here and want it now”. Aspiring Middle Class. Value seekers.",
//     "PopUpInfoIconDescription": "Educational background: University degrees, dominant. Benchmarking with the next above. Desire a predictable life. Spending mid-range budgets on consumer goods and leisure time activities. Want to buy cheap, but not feel cheap. Ready to change for a new attractive offer. Younger members spend and indulge in their present wellbeing.",
//     "FilterDescription": "",
//     "ID": 8
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "Lifestyle",
//     "SubCategory": "04: Conservative Urban Middle Class",
//     "Description(Facebook)": "“Cherish what you have”. Focusing on safeguarding their achievements. Seeking a pleasant and sheltered life without risks and extremes. Eager on social relations with their community and neighbourhood society. Celebrating festivals with great enthusiasm. Predominantly mainstream Indian college education. Typically upper-class salaried jobs. Critically comparing prices and services. National brands and values meet their spending consciousness.",
//     "OneLiner": "“Cherish what you have”. Focusing on safeguarding their achievements.",
//     "PopUpInfoIconDescription": "Seeking a pleasant and sheltered life without risks and extremes. Eager on social relations with their community and neighbourhood society. Celebrating festivals with great enthusiasm. Predominantly mainstream Indian college education. Typically upper-class salaried jobs. Critically comparing prices and services. National brands and values meet their spending consciousness.",
//     "FilterDescription": "",
//     "ID": 9
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "Lifestyle",
//     "SubCategory": "05: Lower Middle Class",
//     "Description(Facebook)": "“Education is the ticket to a better future”. Born from lesser-educated parents, striving to reach higher education levels. Ambitious to be successful in life. Seeking a comfortable, stable life. Focussing on next level professional options away from regular blue-collar jobs. Believing in their own strength. Cautious spenders. Early adopters of new products. ‘Buy Indian’, preferring national brands and technology. Thrifty in details.",
//     "OneLiner": "“Education is the ticket to a better future”. Born from lesser-educated parents, striving to reach higher education levels.",
//     "PopUpInfoIconDescription": "Ambitious to be successful in life. Seeking a comfortable, stable life. Focussing on next level professional options away from regular blue-collar jobs. Believing in their own strength. Cautious spenders. Early adopters of new products. ‘Buy Indian’, preferring national brands and technology. Thrifty in details.",
//     "FilterDescription": "",
//     "ID": 10
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "Lifestyle",
//     "SubCategory": "06: Lower Class",
//     "Description(Facebook)": "“The day is my life”. Typical Day Workers and Labourers. Skilled, but always in search of daily work. Dominantly illiterate. Family and community are the most important ‘back-up’ in life. Focusing their activities on short-term benefits for themselves and their family. Buying decisions on any service or product are solely driven by daily needs and ‘functionality’ at lowest possible costs.",
//     "OneLiner": "“The day is my life”. Typical Day Workers and Labourers.",
//     "PopUpInfoIconDescription": "Skilled, but always in search of daily work. Dominantly illiterate. Family and community are the most important ‘back-up’ in life. Focusing their activities on short-term benefits for themselves and their family. Buying decisions on any service or product are solely driven by daily needs and ‘functionality’ at lowest possible costs.",
//     "FilterDescription": "",
//     "ID": 11
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "NCCS Reference",
//     "SubCategory": "NCCS A1",
//     "Description(Facebook)": "Consumer belongs to a household falling into the NCCS Class A1 for Urban Areas.",
//     "OneLiner": "Consumer belongs to a household falling into the NCCS Class A1 for Urban Areas.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 12
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "NCCS Reference",
//     "SubCategory": "NCCS A2",
//     "Description(Facebook)": "Consumer belongs to a household falling into the NCCS Class A2 for Urban Areas.",
//     "OneLiner": "Consumer belongs to a household falling into the NCCS Class A2 for Urban Areas.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 13
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "NCCS Reference",
//     "SubCategory": "NCCS A3",
//     "Description(Facebook)": "Consumer belongs to a household falling into the NCCS Class A3 for Urban Areas.",
//     "OneLiner": "Consumer belongs to a household falling into the NCCS Class A3 for Urban Areas.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 14
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "NCCS Reference",
//     "SubCategory": "NCCS B1",
//     "Description(Facebook)": "Consumer belongs to a household falling into the NCCS Class B1 for Urban Areas.",
//     "OneLiner": "Consumer belongs to a household falling into the NCCS Class B1 for Urban Areas.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 15
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "NCCS Reference",
//     "SubCategory": "NCCS B2",
//     "Description(Facebook)": "Consumer belongs to a household falling into the NCCS Class B2 for Urban Areas.",
//     "OneLiner": "Consumer belongs to a household falling into the NCCS Class B2 for Urban Areas.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 16
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "NCCS Reference",
//     "SubCategory": "NCCS C1",
//     "Description(Facebook)": "Consumer belongs to a household falling into the NCCS Class C1 for Urban Areas.",
//     "OneLiner": "Consumer belongs to a household falling into the NCCS Class C1 for Urban Areas.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 17
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "NCCS Reference",
//     "SubCategory": "NCCS C2",
//     "Description(Facebook)": "Consumer belongs to a household falling into the NCCS Class C2 for Urban Areas.",
//     "OneLiner": "Consumer belongs to a household falling into the NCCS Class C2 for Urban Areas.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 18
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "NCCS Reference",
//     "SubCategory": "NCCS D1",
//     "Description(Facebook)": "Consumer belongs to a household falling into the NCCS Class D1 for Urban Areas.",
//     "OneLiner": "Consumer belongs to a household falling into the NCCS Class D1 for Urban Areas.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 19
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "NCCS Reference",
//     "SubCategory": "NCCS D2",
//     "Description(Facebook)": "Consumer belongs to a household falling into the NCCS Class D2 for Urban Areas.",
//     "OneLiner": "Consumer belongs to a household falling into the NCCS Class D2 for Urban Areas.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 20
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "NCCS Reference",
//     "SubCategory": "NCCS E1",
//     "Description(Facebook)": "Consumer belongs to a household falling into the NCCS Class E1 for Urban Areas.",
//     "OneLiner": "Consumer belongs to a household falling into the NCCS Class E1 for Urban Areas.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 21
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "NCCS Reference",
//     "SubCategory": "NCCS E2",
//     "Description(Facebook)": "Consumer belongs to a household falling into the NCCS Class E2 for Urban Areas.",
//     "OneLiner": "Consumer belongs to a household falling into the NCCS Class E2 for Urban Areas.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 22
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "NCCS Reference",
//     "SubCategory": "NCCS E3",
//     "Description(Facebook)": "Consumer belongs to a household falling into the NCCS Class E3 for Urban Areas.",
//     "OneLiner": "Consumer belongs to a household falling into the NCCS Class E3 for Urban Areas.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 23
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "Special Health Care Target Group",
//     "SubCategory": "Health Care - ‘The Informed’ In Urban India",
//     "Description(Facebook)": "Typically health conscious consumers in urban areas. They are well accustomed to the benefits of preventive healthcare. Leading a health conscious and wellness focussed life. Willing to spend for maintaining a good health status. Caring about body weight and appearance.",
//     "OneLiner": "Typically health conscious consumers in urban areas.",
//     "PopUpInfoIconDescription": "They are well accustomed to the benefits of preventive healthcare. Leading a health conscious and wellness focussed life. Willing to spend for maintaining a good health status. Caring about body weight and appearance.",
//     "FilterDescription": "",
//     "ID": 24
//   },
//   {
//     "Group": "Consumer Segments",
//     "Category": "Special Health Care Target Group",
//     "SubCategory": "Health Care - ‘The Carefree / Anxious’ In Urban India",
//     "Description(Facebook)": "Typically no distinctive health consciousness. Showing not much interest for preventive health care (healthy food, physical exercise). Knowing mainly traditional medicine. Block out possible health risks and medical issues. Benefit and service conscious, but minimal spender on preventive medical care.",
//     "OneLiner": "Typically no distinctive health consciousness.",
//     "PopUpInfoIconDescription": "Showing not much interest for preventive health care (healthy food, physical exercise). Knowing mainly traditional medicine. Block out possible health risks and medical issues. Benefit and service conscious, but minimal spender on preventive medical care.",
//     "FilterDescription": "",
//     "ID": 25
//   },
//   {
//     "Group": "Financial Products",
//     "Category": "Insurance: Saving Plan",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to holding life insurance ‘Savings Plan’ product(s). Being interested in alternate offerings. Meeting needs in planning ahead for the children’s education and / or wedding, buying a house / apartment or making a dream vacation.",
//     "OneLiner": "High affinity to holding life insurance ‘Savings Plan’ product(s).",
//     "PopUpInfoIconDescription": "Being interested in alternate offerings. Meeting needs in planning ahead for the children’s education and / or wedding, buying a house / apartment or making a dream vacation.",
//     "FilterDescription": "This audience category contains information about individual’s Financial Services such as credit card holders.",
//     "ID": 26
//   },
//   {
//     "Group": "Financial Products",
//     "Category": "Insurance: Retirement Plan",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to life insurance product ‘Retirement Plan’. Strong awareness of increasing life expectancy rate, rising health care costs, absence of social security system and disintegration of joint family system as key reasons for making retirement planning critically important.",
//     "OneLiner": "High affinity to life insurance product ‘Retirement Plan’.",
//     "PopUpInfoIconDescription": "Strong awareness of increasing life expectancy rate, rising health care costs, absence of social security system and disintegration of joint family system as key reasons for making retirement planning critically important.",
//     "FilterDescription": "",
//     "ID": 27
//   },
//   {
//     "Group": "Financial Products",
//     "Category": "Insurance: Unit Linked Plan",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to life insurance product ‘Unit Linked Insurance Plan’. Seeking long term investment plus protection plan and availing market-linked returns while providing life insurance protection.",
//     "OneLiner": "High affinity to life insurance product ‘Unit Linked Insurance Plan’.",
//     "PopUpInfoIconDescription": "Seeking long term investment plus protection plan and availing market-linked returns while providing life insurance protection.",
//     "FilterDescription": "",
//     "ID": 28
//   },
//   {
//     "Group": "Financial Products",
//     "Category": "Insurance: Health Plan",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to insurance product ‘Health Insurance’. Obtaining coverage paying for medical and surgical expenses if incurring. Being reimbursed for expenses deriving from illness or injury treatment.",
//     "OneLiner": "High affinity to insurance product ‘Health Insurance’.",
//     "PopUpInfoIconDescription": "Obtaining coverage paying for medical and surgical expenses if incurring. Being reimbursed for expenses deriving from illness or injury treatment.",
//     "FilterDescription": "",
//     "ID": 29
//   },
//   {
//     "Group": "Financial Products",
//     "Category": "Banking: Mutual Fund",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to banking product ‘Mutual Fund’. Considering to invest in a mutual fund as a pool of money from numerous investors. Preferring these advantages instead of buying and selling individual stocks and bonds.",
//     "OneLiner": "High affinity to banking product ‘Mutual Fund’.",
//     "PopUpInfoIconDescription": "Considering to invest in a mutual fund as a pool of money from numerous investors. Preferring these advantages instead of buying and selling individual stocks and bonds.",
//     "FilterDescription": "",
//     "ID": 30
//   },
//   {
//     "Group": "Financial Products",
//     "Category": "Banking: Fixed Deposit",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to banking product ‘Fixed Deposits’. Attracted to the higher rate of interest than achievable for regular savings account.",
//     "OneLiner": "High affinity to banking product ‘Fixed Deposits’.",
//     "PopUpInfoIconDescription": "Attracted to the higher rate of interest than achievable for regular savings account.",
//     "FilterDescription": "",
//     "ID": 31
//   },
//   {
//     "Group": "Financial Products",
//     "Category": "Banking: Credit Card Holding",
//     "SubCategory": "Expected rare / Irregular Use",
//     "Description(Facebook)": "High affinity to hold a credit card with expected irregular use, more for 'emergencies' and exxceptional situations.",
//     "OneLiner": "High affinity to hold a credit card with expected irregular use, more for 'emergencies' and exxceptional situations.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 32
//   },
//   {
//     "Group": "Financial Products",
//     "Category": "Banking: Credit Card Holding",
//     "SubCategory": "Expected Moderate / Average Use",
//     "Description(Facebook)": "High affinity to hold a credit card with expected moderate use, regularly but not heavy for many payments to be done.",
//     "OneLiner": "High affinity to hold a credit card with expected moderate use, regularly but not heavy for many payments to be done.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 33
//   },
//   {
//     "Group": "Financial Products",
//     "Category": "Banking: Credit Card Holding",
//     "SubCategory": "Expected heavy / Frequent Use",
//     "Description(Facebook)": "High affinity to hold a credit card with expected heavy use, regularly and for many payments 'every other day'.",
//     "OneLiner": "High affinity to hold a credit card with expected heavy use, regularly and for many payments 'every other day'.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 34
//   },
//   {
//     "Group": "Automobile",
//     "Category": "Entry Price - Segment INR 2,00,000 - 4,50,000",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Entry Price Segment INR 2,00,000 - 4,50,000 (Renault Kwid, Suzuki Alto, Datsun GO, Hyundai eon, etc).",
//     "OneLiner": "Renault Kwid, Suzuki Alto, Datsun GO, Hyundai eon, etc",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "Consumers who are likely to own varying types of motor vehicles as well as the affinity to buy cars in a specific price range.",
//     "ID": 35
//   },
//   {
//     "Group": "Automobile",
//     "Category": "Entry Premium Hatch Segment INR 4,00,000 - 7,00,000",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Entry Premium Hatch Segment INR 4,00,000 - 7,00,000 (Suzuki Grand i10, Maruti Suzuki swift, TATA Tiago, Honda Brio, etc.).",
//     "OneLiner": "Suzuki Grand i10, Maruti Suzuki swift, TATA Tiago, Honda Brio, etc",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 36
//   },
//   {
//     "Group": "Automobile",
//     "Category": "Premium Hatch Segment INR 5,50,000 - 9,00,000",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Premium Hatch Segment INR 5,50,000 - 9,00,000 (Hyundai i20, Maruti Suzuki Baleno, VW Polo, Honda Jazz, etc.).",
//     "OneLiner": "Hyundai i20, Maruti Suzuki Baleno, VW Polo, Honda Jazz, etc",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 37
//   },
//   {
//     "Group": "Automobile",
//     "Category": "Compact Sedan Segment INR 5,30,000 - 8,50,000",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Compact Sedan Segment INR 5,30,000 - 8,50,000 (Maruti Suzuki Swift Dzire, Hyundai Xcent, Honda Amaze, Ford Aspire, etc.).",
//     "OneLiner": "Maruti Suzuki Swift Dzire, Hyundai Xcent, Honda Amaze, Ford Aspire, etc",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 38
//   },
//   {
//     "Group": "Automobile",
//     "Category": "Sedan Segment INR 8,00,000 - 13,00,000",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Sedan Segment INR 8,00,000 - 13,00,000 (Honda City, Hyundai Verna, Maruti Suzuki Ciaz, VW Vento, etc.).",
//     "OneLiner": "Honda City, Hyundai Verna, Maruti Suzuki Ciaz, VW Vento, etc",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 39
//   },
//   {
//     "Group": "Automobile",
//     "Category": "Premium Sedan Segment INR 13,00,000 - 20,00,000",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Premium Sedan Segment INR 13,00,000 - 20,00,000 (Toyota Corolla Altis, Toyota Accord, Skoda Superb, Honda Civic, etc.).",
//     "OneLiner": "Toyota Corolla Altis, Toyota Accord, Skoda Superb, Honda Civic, etc",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 40
//   },
//   {
//     "Group": "Automobile",
//     "Category": "Compact / Entry SUV Segment INR 9,00,000 - 14,00,000",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Compact / Entry SUV Segment INR 9,00,000 - 14,00,000 (Ford Ecosport, Suzuki S-Cross, Honda BRV, Suzuki Ertiga, etc.).",
//     "OneLiner": "Ford Ecosport, Suzuki S-Cross, Honda BRV, Suzuki Ertiga, etc",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 41
//   },
//   {
//     "Group": "Automobile",
//     "Category": "SUV Segment INR 15,00,000 - 30,00,000",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the SUV Segment INR 15,00,000 - 30,00,000 (Toyota Fortuner, Ford Endeavour, TATA Aria, etc.)",
//     "OneLiner": "Toyota Fortuner, Ford Endeavour, TATA Aria, etc",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 42
//   },
//   {
//     "Group": "Automobile",
//     "Category": "Luxury Premium Sedan & SUV Segment INR 25,00,000+",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Luxury Premium Sedan & SUV Segment INR 25,00,000+ (BMW, Mercedes, AUDI, VW).",
//     "OneLiner": "BMW, Mercedes, AUDI, VW",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 43
//   },
//   {
//     "Group": "Automobile",
//     "Category": "Second-hand Sedan Segment",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy a second-hand Sedan Segment car (Honda City, Hyundai Verna, Maruti Suzuki Ciaz, VW Vento, etc.).",
//     "OneLiner": "Honda City, Hyundai Verna, Maruti Suzuki Ciaz, VW Vento, etc",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 44
//   },
//   {
//     "Group": "Automobile",
//     "Category": "Second-hand Premium Sedan / SUV Segment",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy a second-hand Premium Sedan / SUV Segment car (Toyota Corolla Altis, Toyota Accord, Skoda Suberb, Honda Civic, Toyota Fortuner, Ford Endeavour, TATA Aria etc.).",
//     "OneLiner": "Toyota Corolla Altis, Toyota Accord, Skoda Suberb, Honda Civic, Toyota Fortuner, Ford Endeavour, TATA Aria etc.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 45
//   },
//   {
//     "Group": "Automobile",
//     "Category": "Second-hand Luxury Premium Sedan & SUV Segment",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy a second-hand Luxury Premium Sedan & SUV Segment car (BMW, Mercedes, AUDI, VW).",
//     "OneLiner": "BMW, Mercedes, AUDI, VW",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 46
//   },
//   {
//     "Group": "Real Estate",
//     "Category": "Purchase Price Segment: INR 15,00,000 - 25,00,000",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy a property in the price range INR 15,00,000 - 25,00,000.",
//     "OneLiner": "High affinity to buy a property in the price range INR 15,00,000 - 25,00,000.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "This audience category contains information about Home and Property ownership as well as expenditures for it.",
//     "ID": 47
//   },
//   {
//     "Group": "Real Estate",
//     "Category": "Purchase Price Segment: INR 25,00,000 - 50,00,000",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy a property in the price range INR 25,00,000 - 50,00,000.",
//     "OneLiner": "High affinity to buy a property in the price range INR 25,00,000 - 50,00,000.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 48
//   },
//   {
//     "Group": "Real Estate",
//     "Category": "Purchase Price Segment: INR 51,00,000 - 1 Crore",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy a property in the price range INR 51,00,000 - 1,00,00,000.",
//     "OneLiner": "High affinity to buy a property in the price range INR 51,00,000 - 1,00,00,000.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 49
//   },
//   {
//     "Group": "Real Estate",
//     "Category": "Purchase Price Segment: INR 1 - 4 Crore",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy a property in the price range INR 1 - 4 Crore.",
//     "OneLiner": "High affinity to buy a property in the price range INR 1 - 4 Crore.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 50
//   },
//   {
//     "Group": "Real Estate",
//     "Category": "Purchase Price Segment: Beyond INR 4 Crore",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy a property in the price range beyond INR 4 Crore.",
//     "OneLiner": "High affinity to buy a property in the price range beyond INR 4 Crore.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 51
//   },
//   {
//     "Group": "FMCG",
//     "Category": "Laundry",
//     "SubCategory": "Fabric Wash Products: Mass Classified",
//     "Description(Facebook)": "High affinity in the category ‘laundry’ to buy mass fabric wash products: practical, effective, focused on basic performance (Wheel, etc.).",
//     "OneLiner": "High affinity to buy mass fabric wash products: practical, effective, focused on basic performance (Wheel, etc.).",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "Consumers who are likely to purchase goods across various product categories including Food, Personal Wash, Beauty, Home and Living.",
//     "ID": 52
//   },
//   {
//     "Group": "FMCG",
//     "Category": "Laundry",
//     "SubCategory": "Fabric Wash Products: Premium Classified",
//     "Description(Facebook)": "High affinity in the category ‘laundry’ to buy premium fabric wash products. Clean clothes for creating a positive impression and being recognized by society. Special fragrance conscious. (Rin, Sunlight, etc.).",
//     "OneLiner": "High affinity to buy premium fabric wash products. Clean clothes for creating a positive impression and being recognized by society. Special fragrance conscious. (Rin, Sunlight, etc.).",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 53
//   },
//   {
//     "Group": "FMCG",
//     "Category": "Laundry",
//     "SubCategory": "Washing Machine Products",
//     "Description(Facebook)": "High affinity in the category ‘detergents’ and ‘laundry’ to buy products for washing machine use (Surf Excel, etc.).",
//     "OneLiner": "High affinity in the category ‘detergents’ and ‘laundry’ to buy products for washing machine use (Surf Excel, etc.).",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 54
//   },
//   {
//     "Group": "FMCG",
//     "Category": "Personal Wash",
//     "SubCategory": "Mass Classified Products",
//     "Description(Facebook)": "High affinity in the category ‘personal wash’ to buy mass classified products. Convenience and pricing fulfilling basic needs (Lifebuoy, Breeze, Clinic, etc.).",
//     "OneLiner": "High affinity to buy mass classified products. Convenience and pricing fulfilling basic needs (Lifebuoy, Breeze, Clinic, etc.).",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 55
//   },
//   {
//     "Group": "FMCG",
//     "Category": "Personal Wash",
//     "SubCategory": "Popular Classified Products",
//     "Description(Facebook)": "High affinity in the category ‘personal wash’ to buy popular classified products Eager to be trendy, getting the “million dollar” feeling (Rexone, Lux, Hamam, Sunsilk, Pepsodent, etc.).",
//     "OneLiner": "High affinity to buy popular classified products Eager to be trendy, getting the “million dollar” feeling (Rexone, Lux, Hamam, Sunsilk, Pepsodent, etc.).",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 56
//   },
//   {
//     "Group": "FMCG",
//     "Category": "Personal Wash",
//     "SubCategory": "Premium Classified Products",
//     "Description(Facebook)": "High affinity in the category ‘personal wash’ to buy premium classified products. Health and ingredients conscious, looking for exquisite products (Dove, Ponds, Closeup, Tresemme, etc.).",
//     "OneLiner": "High affinity to buy premium classified products. Health and ingredients conscious, looking for exquisite products (Dove, Ponds, Closeup, Tresemme, etc.).",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 57
//   },
//   {
//     "Group": "FMCG",
//     "Category": "Packaged Food",
//     "SubCategory": "Mass Classified Products",
//     "Description(Facebook)": "High affinity in the category ‘packaged food’ to buy mass classified products. Convenience and price conscious, accepting non organic basis. Seeking to be fancy and modern, having quick meals and drinks.",
//     "OneLiner": "High affinity to buy mass classified products. Convenience and price conscious, accepting non organic basis. Seeking to be fancy and modern, having quick meals and drinks.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 58
//   },
//   {
//     "Group": "FMCG",
//     "Category": "Packaged Food",
//     "SubCategory": "Premium Classified Products",
//     "Description(Facebook)": "High affinity in the category ‘packaged food’ to buy premium classified products. Seeking high quality, willing to pay higher prices. Associates safety with higher price and being modern. Health driven, searching for natural products. Organic and nutrition conscious.",
//     "OneLiner": "High affinity to buy premium classified products. Seeking high quality, willing to pay higher prices. Associates safety with higher price and being modern. Health driven, searching for natural products. Organic and nutrition conscious.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 59
//   },
//   {
//     "Group": "FMCG",
//     "Category": "Cosmetics",
//     "SubCategory": "Mass Classified Products",
//     "Description(Facebook)": "High affinity in the category ‘cosmetics’ to buy mass classified products. Convenience and price conscious, fulfilling basic needs.",
//     "OneLiner": "High affinity to buy mass classified products. Convenience and price conscious, fulfilling basic needs.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 60
//   },
//   {
//     "Group": "FMCG",
//     "Category": "Cosmetics",
//     "SubCategory": "Popular Classified Products",
//     "Description(Facebook)": "High affinity in the category ‘cosmetics’ to buy popular branded products. Trendy, giving the “million dollar” feeling.",
//     "OneLiner": "High affinity to buy popular branded products. Trendy, giving the “million dollar” feeling.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 61
//   },
//   {
//     "Group": "FMCG",
//     "Category": "Cosmetics",
//     "SubCategory": "Premium Classified Products",
//     "Description(Facebook)": "High affinity in the category ‘cosmetics’ to buy premium classified products. Affinity to luxury. Exquisite, top branded products.",
//     "OneLiner": "High affinity to buy premium classified products. Affinity to luxury. Exquisite, top branded products.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 62
//   },
//   {
//     "Group": "Fashion & Apparel",
//     "Category": "Purchase Price Category",
//     "SubCategory": "Economy (typically INR 500 - 800)",
//     "Description(Facebook)": "High affinity to buy clothes and foot ware in the price category \"Economy\" INR Below 800.",
//     "OneLiner": "High affinity to buy clothes and foot ware in the price category \"Economy\" INR Below 800.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 63
//   },
//   {
//     "Group": "Fashion & Apparel",
//     "Category": "Purchase Price Category",
//     "SubCategory": "Medium (typically INR 800 - 1,500)",
//     "Description(Facebook)": "High affinity to buy clothes and foot ware in the price category \"Medium\" INR 800 - 2,000.",
//     "OneLiner": "High affinity to buy clothes and foot ware in the price category \"Medium\" INR 800 - 2,000.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 64
//   },
//   {
//     "Group": "Fashion & Apparel",
//     "Category": "Purchase Price Category",
//     "SubCategory": "Premium (typically INR 1,500 - 3,500)",
//     "Description(Facebook)": "High affinity to buy clothes and foot ware in the price category \"Premium\" INR 2,000 - 3,500.",
//     "OneLiner": "High affinity to buy clothes and foot ware in the price category \"Premium\" INR 2,000 - 3,500.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 65
//   },
//   {
//     "Group": "Fashion & Apparel",
//     "Category": "Purchase Price Category",
//     "SubCategory": "Super Premium (typically INR 3,500 - 7,000)",
//     "Description(Facebook)": "High affinity to buy clothes and foot ware in the price category \"Super Premium\" INR 3,500 - 7,000.",
//     "OneLiner": "High affinity to buy clothes and foot ware in the price category \"Super Premium\" INR 3,500 - 7,000.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 66
//   },
//   {
//     "Group": "Fashion & Apparel",
//     "Category": "Purchase Price Category",
//     "SubCategory": "Luxury (typically INR 7,000+)",
//     "Description(Facebook)": "High affinity to buy clothes and foot ware in the price category \"Luxury\" INR 7,000 +.",
//     "OneLiner": "High affinity to buy clothes and foot ware in the price category \"Luxury\" INR 7,000 +.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 67
//   },
//   {
//     "Group": "Jewellery & Gold",
//     "Category": "Category: Total",
//     "SubCategory": "Branded Jewellery",
//     "Description(Facebook)": "High Affinity to buying branded jewellery, contemporary and stylish. Having confidence in name reputation and guarantees.",
//     "OneLiner": "High Affinity to buying branded jewellery, contemporary and stylish. Having confidence in name reputation and guarantees.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "Consumers who are likely to purchase goods across various product categories including Gold and Jewellery.",
//     "ID": 68
//   },
//   {
//     "Group": "Jewellery & Gold",
//     "Category": "Category: Total",
//     "SubCategory": "Traditional / Non-branded Jewellery",
//     "Description(Facebook)": "High Affinity to buying traditional / non-branded jewellery, tailor-made according to own preferences.",
//     "OneLiner": "High Affinity to buying traditional / non-branded jewellery, tailor-made according to own preferences.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 69
//   },
//   {
//     "Group": "Jewellery & Gold",
//     "Category": "Category: Gold",
//     "SubCategory": "Moderately priced Gold Jewellery",
//     "Description(Facebook)": "High Affinity to buying moderately priced gold jewellery. Expecting to look astonishingly beautiful with gold jewellery and wearing gold as lucky omen with blessings of goddesses.",
//     "OneLiner": "High Affinity to buying moderately priced gold jewellery. Expecting to look astonishingly beautiful with gold jewellery and wearing gold as lucky omen with blessings of goddesses.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 70
//   },
//   {
//     "Group": "Jewellery & Gold",
//     "Category": "Category: Gold",
//     "SubCategory": "High priced Gold Jewellery",
//     "Description(Facebook)": "High Affinity to buying high priced gold jewellery. Expecting to look astonishingly beautiful with gold jewellery and wearing gold as lucky omen with blessings of goddesses.",
//     "OneLiner": "High Affinity to buying high priced gold jewellery. Expecting to look astonishingly beautiful with gold jewellery and wearing gold as lucky omen with blessings of goddesses.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 71
//   },
//   {
//     "Group": "Jewellery & Gold",
//     "Category": "Category: Diamond",
//     "SubCategory": "Moderately priced Diamond Jewellery",
//     "Description(Facebook)": "High Affinity to buying moderately priced diamond jewellery. Wearing (branded) diamond jewellery as level of modern exclusivity and luxury.",
//     "OneLiner": "High Affinity to buying moderately priced diamond jewellery. Wearing (branded) diamond jewellery as level of modern exclusivity and luxury.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 72
//   },
//   {
//     "Group": "Jewellery & Gold",
//     "Category": "Category: Diamond",
//     "SubCategory": "High priced Diamond Jewellery",
//     "Description(Facebook)": "High Affinity to buying high priced diamond jewellery. Wearing (branded) diamond jewellery as level of modern exclusivity and luxury.",
//     "OneLiner": "High Affinity to buying high priced diamond jewellery. Wearing (branded) diamond jewellery as level of modern exclusivity and luxury.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 73
//   },
//   {
//     "Group": "Travel",
//     "Category": "Short Term Holidays",
//     "SubCategory": "Category typically 'Basic'",
//     "Description(Facebook)": "High Affinity to go on weekend get-aways, standard quality destinations - appreciating basic amenities.",
//     "OneLiner": "High Affinity to go on weekend get-aways, standard quality destinations - appreciating basic amenities.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "Consumers who are likely to travel are part of these segments. Information about their travel habits, like destination and spending, is provided.",
//     "ID": 74
//   },
//   {
//     "Group": "Travel",
//     "Category": "Short Term Holidays",
//     "SubCategory": "Category typically 'Luxury'",
//     "Description(Facebook)": "High Affinity to go on weekend get-aways, luxury destinations - wellness and high comfort focussed.",
//     "OneLiner": "High Affinity to go on weekend get-aways, luxury destinations - wellness and high comfort focussed.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 75
//   },
//   {
//     "Group": "Travel",
//     "Category": "Long Term Holidays",
//     "SubCategory": "Destination typically 'National'",
//     "Description(Facebook)": "High Affinity to go on trips under 10 days, national destinations.",
//     "OneLiner": "High Affinity to go on trips under 10 days, national destinations.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 76
//   },
//   {
//     "Group": "Travel",
//     "Category": "Long Term Holidays",
//     "SubCategory": "Destination typically 'International'",
//     "Description(Facebook)": "High Affinity to go on trips longer than 10 days, worldwide destinations inlcuding cruises.",
//     "OneLiner": "High Affinity to go on trips longer than 10 days, worldwide destinations inlcuding cruises.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 77
//   },
//   {
//     "Group": "Travel",
//     "Category": "Long Term Holidays",
//     "SubCategory": "",
//     "Description(Facebook)": "High Affinity to go on niche / specialty tours - keen on experiencing cultural differences, unknown sites and exploring new places.",
//     "OneLiner": "High Affinity to go on niche / specialty tours - keen on experiencing cultural differences, unknown sites and exploring new places.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 78
//   },
//   {
//     "Group": "Retail",
//     "Category": "High Frequency Online Shopping",
//     "SubCategory": "",
//     "Description(Facebook)": "High Affinity to shop more online than offline (typically 75% of purchases are done online)",
//     "OneLiner": "High Affinity to shop more online than offline (typically 75% of purchases are done online)",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 79
//   },
//   {
//     "Group": "Retail",
//     "Category": "Home and Living",
//     "SubCategory": "Typically 'High Priced' Purchases",
//     "Description(Facebook)": "High Affinity to buy international style, high-priced furniture.",
//     "OneLiner": "High Affinity to buy international style, high-priced furniture.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 80
//   },
//   {
//     "Group": "Retail",
//     "Category": "Home and Living",
//     "SubCategory": "Typically 'Moderate Priced' Purchases",
//     "Description(Facebook)": "High Affinity to buy common style, mid-priced furniture.",
//     "OneLiner": "High Affinity to buy common style, mid-priced furniture.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 81
//   },
//   {
//     "Group": "Two Wheeler",
//     "Category": "Entry Level Scooter Segment",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Entry Level Scooter Segment",
//     "OneLiner": "High affinity to buy in the Entry Level Scooter Segment",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "Consumers who are likely to own varying types of Two Wheelers as well as the affinity to buy in a specific price range.",
//     "ID": 82
//   },
//   {
//     "Group": "Two Wheeler",
//     "Category": "Premium Scooter Segment",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Premium Scooter Segment",
//     "OneLiner": "High affinity to buy in the Premium Scooter Segment",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 83
//   },
//   {
//     "Group": "Two Wheeler",
//     "Category": "Entry Level Commuter Segment",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Entry Level Commuter Segment",
//     "OneLiner": "High affinity to buy in the Entry Level Commuter Segment",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 84
//   },
//   {
//     "Group": "Two Wheeler",
//     "Category": "Premium Commuter Segment",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Premium Commuter Segment",
//     "OneLiner": "High affinity to buy in the Premium Commuter Segment",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 85
//   },
//   {
//     "Group": "Two Wheeler",
//     "Category": "Entry Level Sports Bike Segment",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Entry Level Sports Bike Segment",
//     "OneLiner": "High affinity to buy in the Entry Level Sports Bike Segment",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 86
//   },
//   {
//     "Group": "Two Wheeler",
//     "Category": "Premium Sports Bike Segment",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Premium Sports Bike Segment",
//     "OneLiner": "High affinity to buy in the Premium Sports Bike Segment",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 87
//   },
//   {
//     "Group": "Two Wheeler",
//     "Category": "Entry Level Cruiser Bike Segment",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Entry Level Cruiser Bike Segment",
//     "OneLiner": "High affinity to buy in the Entry Level Cruiser Bike Segment",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 88
//   },
//   {
//     "Group": "Two Wheeler",
//     "Category": "Premium Cruiser Bike Segment",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Premium Cruiser Bike Segment",
//     "OneLiner": "High affinity to buy in the Premium Cruiser Bike Segment",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 89
//   },
//   {
//     "Group": "Two Wheeler",
//     "Category": "Touring Bike Segment",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Touring Bike Segment",
//     "OneLiner": "High affinity to buy in the Touring Bike Segment",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 90
//   },
//   {
//     "Group": "Two Wheeler",
//     "Category": "Off Road Bike Segment",
//     "SubCategory": "",
//     "Description(Facebook)": "High affinity to buy in the Off Road Bike Segment",
//     "OneLiner": "High affinity to buy in the Off Road Bike Segment",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 91
//   },
//   {
//     "Group": "Retail",
//     "Category": "High Frequency Online Shopping",
//     "SubCategory": "",
//     "Description(Facebook)": "Expected irregular use affinity for online shopping",
//     "OneLiner": "Expected irregular use affinity for online shopping",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 92
//   },
//   {
//     "Group": "Retail",
//     "Category": "High Frequency Online Shopping",
//     "SubCategory": "",
//     "Description(Facebook)": "Expected moderate use affinity for online shopping",
//     "OneLiner": "Expected moderate use affinity for online shopping",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 93
//   },
//   {
//     "Group": "Retail",
//     "Category": "High Frequency Online Shopping",
//     "SubCategory": "",
//     "Description(Facebook)": "Expected expected heavy use affinity for online shopping",
//     "OneLiner": "Expected expected heavy use affinity for online shopping",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 94
//   },
//   {
//     "Group": "FMCG",
//     "Category": "Packaged Food",
//     "SubCategory": "Popular Classified Products",
//     "Description(Facebook)": "High affinity in the category ‘packaged food’ to buy popular classified products. Seeking high quality, willing to pay higher prices. Associates safety with higher price and being modern. Health driven, searching for natural products. Organic and nutrition conscious.",
//     "OneLiner": "High affinity to buy popular classified products. Seeking high quality, willing to pay higher prices. Associates safety with higher price and being modern. Health driven, searching for natural products. Organic and nutrition conscious.",
//     "PopUpInfoIconDescription": "",
//     "FilterDescription": "",
//     "ID": 95
//   },
//  ]


export const KentrixFiltersDescription = [
  {'ID': -1,
  'Group': 'Regio-type : Urban',
  'Category': 'Regio_Type',
  'SubCategory': '01: Cosmopolitan Urban Area',
  'Description(Facebook)': '',
  'FilterDescription': 'Demographic information such as Affluence and income are provided in these segments.',
  'PopUpInfoIconDescription': 'aa',
  'OneLiner': ''},
  {'ID': 0,
  'Group': 'Regio-type : Urban',
  'Category': 'Regio_Type',
  'SubCategory': '02: Sub-Metropolitan Urban Area',
  'Description(Facebook)': '',
  'FilterDescription': 'Demographic information such as Affluence and income are provided in these segments.',
  'PopUpInfoIconDescription': 'aa',
  'OneLiner': ''},
  {'ID': 1,
  'Group': 'Regio-type : Urban',
  'Category': 'Regio_Type',
  'SubCategory':  '03: Small Urban Area',
  'Description(Facebook)': '',
  'FilterDescription': 'Demographic information such as Affluence and income are provided in these segments.',
  'PopUpInfoIconDescription': 'aa',
  'OneLiner': ''},
  {'ID': 2,
  'Group': 'Regio-type : Urban',
  'Category': 'Regio_Type',
  'SubCategory':  '04: Semi Urban Area',
  'Description(Facebook)': '',
  'FilterDescription': 'Demographic information such as Affluence and income are provided in these segments.',
  'PopUpInfoIconDescription': 'aa',
  'OneLiner': ''},

  {'ID': 3,
  'Group': 'Socio-Economic Profile',
  'Category': 'Income',
  'SubCategory': 'Emerging Spenders (₹40K–₹80K)',
  'Description(Facebook)': 'Consumer is living in an urban area, where the monthly household-level income is typically “Medium (INR 40,000 – 80,000).',
  'FilterDescription': 'Demographic information such as Affluence and income are provided in these segments.',
  'PopUpInfoIconDescription': 'Consumer is living in an urban area, where the monthly household-level income is typically “Medium (INR 40,000 – 80,000).',
  'OneLiner': ''},
 {'ID': 4,
  'Group': 'Socio-Economic Profile',
  'Category': 'Income',
  'SubCategory': 'Mid-Level Buyers (₹80K–₹1.3L)',
  'Description(Facebook)': 'Consumer is living in an urban area, where the monthly household-level income is typically “Medium Good” (INR 80,000 – 1,30,000).',
  'FilterDescription': 'Demographic information such as Affluence and income are provided in these segments.',
  'PopUpInfoIconDescription': 'Consumer is living in an urban area, where the monthly household-level income is typically “Medium Good” (INR 80,000 – 1,30,000).',
  'OneLiner': ''},
 {'ID': 5,
  'Group': 'Socio-Economic Profile',
  'Category': 'Income',
  'SubCategory': 'Comfortable Earners (₹1.3L–₹2.3L)',
  'Description(Facebook)': 'Consumer is living in an urban area, where the monthly household-level income is typically  Good” (INR 1,30,000 – 2,30,000).',
  'FilterDescription': 'Demographic information such as Affluence and income are provided in these segments.',
  'PopUpInfoIconDescription': 'Consumer is living in an urban area, where the monthly household-level income is typically  Good” (INR 1,30,000 – 2,30,000).',
  'OneLiner': ''},
{'ID': 7,
  'Group': 'Socio-Economic Profile',
  'Category': 'Income',
  'SubCategory': 'Premium Buyers (₹2.3L-₹3L)',
  'Description(Facebook)': 'Consumer is living in an urban area, where the monthly household-level income is typically "High” (INR 2,30,000-3,00,000). ',
  'FilterDescription': 'Provides income and affluence details to classify consumers by economic status.',
  'PopUpInfoIconDescription': 'Consumer is living in an urban area, where the monthly household-level income is typically "High” (INR 2,30,000-3,00,000). ',
  'OneLiner': ''},
 {'ID': 8,
  'Group': 'Socio-Economic Profile',
  'Category': 'Income',
  'SubCategory': 'Super Premium Buyers (Above ₹3L)',
  'Description(Facebook)': 'Consumer is living in an urban area, where the monthly household-level income is typically "Very High” (INR >3,00,000). ',
  'FilterDescription': 'Provides income and affluence details to classify consumers by economic status.',
  'PopUpInfoIconDescription': 'Consumer is living in an urban area, where the monthly household-level income is typically "Very High” (INR >3,00,000). ',
  'OneLiner': ''},
 {'ID': 9,
  'Group': 'Consumer Segments',
  'Category': 'Lifestyle',
  'SubCategory': 'Lifestyle Segment 01: Urban Established Elite',
  'Description(Facebook)': '“The world is our playground”. Wealthy, educated families. Attended (inter)national leading educational institutes. Accustomed to international luxury and quality standards. Global mind-set. Sophisticated orientations in style and taste. Self-confident. Individual, liberal attitudes. Financially secure. Highly brand conscious. Shop for status, not for price. Memberships in selected Private Clubs. Outdoor dining, exquisite restaurants.',
  'FilterDescription': 'Segments the population into different categories based on demographic information and consumption habits like consumption and social status.',
  'PopUpInfoIconDescription': '“The world is our playground”. Wealthy, educated families. Attended (inter)national leading educational institutes. Accustomed to international luxury and quality standards. Global mind-set. Sophisticated orientations in style and taste. Self-confident. Individual, liberal attitudes. Financially secure. Highly brand conscious. Shop for status, not for price. Memberships in selected Private Clubs. Outdoor dining, exquisite restaurants.',
  'OneLiner': ''},
 {'ID': 10,
  'Group': 'Consumer Segments',
  'Category': 'Lifestyle',
  'SubCategory': 'Lifestyle Segment 02: Urban New Wealth',
  'Description(Facebook)': '“We are the new cosmopolitan leaders”. Newly arrived, status conscious Upper Class. Having gained their professional platform and recognition based upon their high-level education. Ambitious, convinced in their own strength. Developing international perspectives. Striving for the exquisite taste. Easy to be led in search for top class quality and comfort standards. Memberships in Private Clubs. Outdoor dining, high class restaurants.',
  'FilterDescription': 'Segments the population into different categories based on demographic information and consumption habits like consumption and social status.',
  'PopUpInfoIconDescription': '“We are the new cosmopolitan leaders”. Newly arrived, status conscious Upper Class. Having gained their professional platform and recognition based upon their high-level education. Ambitious, convinced in their own strength. Developing international perspectives. Striving for the exquisite taste. Easy to be led in search for top class quality and comfort standards. Memberships in Private Clubs. Outdoor dining, high class restaurants.',
  'OneLiner': ''},
 {'ID': 11,
  'Group': 'Consumer Segments',
  'Category': 'Lifestyle',
  'SubCategory': 'Lifestyle Segment 03: Aspiring Urban Middle Class',
  'Description(Facebook)': '“We are here and want it now”. Aspiring Middle Class. Value seekers. Educational background: University degrees, dominant. Benchmarking with the next above. Desire a predictable life. Spending mid-range budgets on consumer goods and leisure time activities. Want to buy cheap, but not feel cheap. Ready to change for a new attractive offer. Younger members spend and indulge in their present wellbeing.',
  'FilterDescription': 'Segments the population into different categories based on demographic information and consumption habits like consumption and social status.',
  'PopUpInfoIconDescription': '“We are here and want it now”. Aspiring Middle Class. Value seekers. Educational background: University degrees, dominant. Benchmarking with the next above. Desire a predictable life. Spending mid-range budgets on consumer goods and leisure time activities. Want to buy cheap, but not feel cheap. Ready to change for a new attractive offer. Younger members spend and indulge in their present wellbeing.',
  'OneLiner': ''},
 {'ID': 12,
  'Group': 'Consumer Segments',
  'Category': 'Lifestyle',
  'SubCategory': 'Lifestyle Segment 04: Conservative Urban Middle Class',
  'Description(Facebook)': '“Cherish what you have”. Focusing on safeguarding their achievements. Seeking a pleasant and sheltered life without risks and extremes. Eager on social relations with their community and neighbourhood society. Celebrating festivals with great enthusiasm. Predominantly mainstream Indian college education. Typically upper-class salaried jobs. Critically comparing prices and services. National brands and values meet their spending consciousness.',
  'FilterDescription': 'Segments the population into different categories based on demographic information and consumption habits like consumption and social status.',
  'PopUpInfoIconDescription': '“Cherish what you have”. Focusing on safeguarding their achievements. Seeking a pleasant and sheltered life without risks and extremes. Eager on social relations with their community and neighbourhood society. Celebrating festivals with great enthusiasm. Predominantly mainstream Indian college education. Typically upper-class salaried jobs. Critically comparing prices and services. National brands and values meet their spending consciousness.',
  'OneLiner': ''},
 {'ID': 13,
  'Group': 'Consumer Segments',
  'Category': 'Lifestyle',
  'SubCategory': 'Lifestyle Segment 05: Successful Urban Fast Climbers',
  'Description(Facebook)': '“Education is the ticket to a better future”. Born from lesser-educated parents, striving to reach higher education levels. Ambitious to be successful in life. Seeking a comfortable, stable life. Focussing on next level professional options away from regular blue-collar jobs. Believing in their own strength. Cautious spenders. Early adopters of new products. ‘Buy Indian’, preferring national brands and technology. Thrifty in details. ',
  'FilterDescription': 'Segments the population into different categories based on demographic information and consumption habits like consumption and social status.',
  'PopUpInfoIconDescription': '“Education is the ticket to a better future”. Born from lesser-educated parents, striving to reach higher education levels. Ambitious to be successful in life. Seeking a comfortable, stable life. Focussing on next level professional options away from regular blue-collar jobs. Believing in their own strength. Cautious spenders. Early adopters of new products. ‘Buy Indian’, preferring national brands and technology. Thrifty in details. ',
  'OneLiner': ''},
 {'ID': 14,
  'Group': 'Consumer Segments',
  'Category': 'Lifestyle',
  'SubCategory': 'Lifestyle Segment 06: Upcoming Urban Climbers',
  'Description(Facebook)': '“Completing that upgrade training course, will make my life better”. Ambitious to ascend from their current, skilled worker level. Focussing on ambitious goals, although missing the knowledge and skills to pursue them in a systematic way. Closing their eyes to the “confusing” wider / global world. Pragmatic and basic need driven consumer behaviour. Typically going for ‘quick fix’ services and products, functional and local focus. ',
  'FilterDescription': 'Segments the population into different categories based on demographic information and consumption habits like consumption and social status.',
  'PopUpInfoIconDescription': '“Completing that upgrade training course, will make my life better”. Ambitious to ascend from their current, skilled worker level. Focussing on ambitious goals, although missing the knowledge and skills to pursue them in a systematic way. Closing their eyes to the “confusing” wider / global world. Pragmatic and basic need driven consumer behaviour. Typically going for ‘quick fix’ services and products, functional and local focus. ',
  'OneLiner': ''},
 {'ID': 15,
  'Group': 'Consumer Segments',
  'Category': 'Lifestyle',
  'SubCategory': 'Lifestyle Segment 07: Striving Urban Climbers',
  'Description(Facebook)': '“The day is my life”. Typical Day Workers and Labourers. Skilled, but always in search of daily work. Dominantly illiterate. Family and community are the most important ‘back-up’ in life. Focusing their activities on short-term benefits for themselves and their family. Buying decisions on any service or product are solely driven by daily needs and ‘functionality’ at lowest possible costs. ',
  'FilterDescription': 'Segments the population into different categories based on demographic information and consumption habits like consumption and social status.',
  'PopUpInfoIconDescription': '“The day is my life”. Typical Day Workers and Labourers. Skilled, but always in search of daily work. Dominantly illiterate. Family and community are the most important ‘back-up’ in life. Focusing their activities on short-term benefits for themselves and their family. Buying decisions on any service or product are solely driven by daily needs and ‘functionality’ at lowest possible costs. ',
  'OneLiner': ''},
 {'ID': 30,
  'Group': 'Consumer Segments',
  'Category': 'Special Health Care Target Group',
  'SubCategory': 'Special Health Care Target Group ‘The Informed’',
  'Description(Facebook)': 'Health conscious consumers in urban areas. They are well accustomed to the benefits of preventive healthcare. Leading a health conscious and wellness focussed life. Willing to spend for maintaining a good health status. Caring about body weight and appearance. ',
  'FilterDescription': 'Special Health Care Target Group',
  'PopUpInfoIconDescription': 'Health conscious consumers in urban areas. They are well accustomed to the benefits of preventive healthcare. Leading a health conscious and wellness focussed life. Willing to spend for maintaining a good health status. Caring about body weight and appearance. ',
  'OneLiner': ''},
 {'ID': 31,
  'Group': 'Consumer Segments',
  'Category': 'Special Health Care Target Group',
  'SubCategory': 'Special Health Care Target Group ‘The Carefree / Anxious’',
  'Description(Facebook)': 'No distinctive health consciousness. Showing not much interest for preventive health care (healthy food, physical exercise). Knowing mainly traditional medicine. Block out possible health risks and medical issues. Benefit and service conscious, but minimal spender on preventive medical care.',
  'FilterDescription': 'Special Health Care Target Group',
  'PopUpInfoIconDescription': 'No distinctive health consciousness. Showing not much interest for preventive health care (healthy food, physical exercise). Knowing mainly traditional medicine. Block out possible health risks and medical issues. Benefit and service conscious, but minimal spender on preventive medical care.',
  'OneLiner': ''},
 {'ID': 33,
  'Group': 'Financial > Insurance',
  'Category': 'Insurance: Retirement Plan',
  'SubCategory': 'Financial Insurance - Retirement Plan',
  'Description(Facebook)': 'High affinity to life insurance product ‘Retirement Plan’. Strong awareness of increasing life expectancy rate, rising health care costs, absence of social security system and disintegration of joint family system as key reasons for making retirement planning critically important.',
  'FilterDescription': 'This audience category contains information about individual’s Financial Services such as credit card holders.',
  'PopUpInfoIconDescription': 'High affinity to life insurance product ‘Retirement Plan’. Strong awareness of increasing life expectancy rate, rising health care costs, absence of social security system and disintegration of joint family system as key reasons for making retirement planning critically important.',
  'OneLiner': ''},
 {'ID': 34,
  'Group': 'Financial > Insurance',
  'Category': 'Insurance: Unit Linked Plan',
  'SubCategory': 'Financial Insurance - Unit Linked Plan',
  'Description(Facebook)': 'High affinity to life insurance product ‘Unit Linked Insurance Plan’. Seeking long term investment plus protection plan and availing market-linked returns while providing life insurance protection.',
  'FilterDescription': 'This audience category contains information about individual’s Financial Services such as credit card holders.',
  'PopUpInfoIconDescription': 'High affinity to life insurance product ‘Unit Linked Insurance Plan’. Seeking long term investment plus protection plan and availing market-linked returns while providing life insurance protection.',
  'OneLiner': ''},
 {'ID': 35,
  'Group': 'Financial > Banking',
  'Category': 'Banking: Mutual Fund',
  'SubCategory': 'Financial Banking - Mutual Fund',
  'Description(Facebook)': 'High affinity to banking product ‘Mutual Fund’. Considering to invest in a mutual fund as a pool of money from numerous investors. Preferring these advantages instead of buying and selling individual stocks and bonds. ',
  'FilterDescription': 'This audience category contains information about individual’s Financial Services such as credit card holders.',
  'PopUpInfoIconDescription': 'High affinity to banking product ‘Mutual Fund’. Considering to invest in a mutual fund as a pool of money from numerous investors. Preferring these advantages instead of buying and selling individual stocks and bonds. ',
  'OneLiner': ''},
 {'ID': 37,
  'Group': 'Financial > Banking',
  'Category': 'Banking: Fixed Deposit',
  'SubCategory': 'Financial Banking - Fixed Deposit',
  'Description(Facebook)': 'High affinity to banking product ‘Fixed Deposits’. Attracted to the higher rate of interest than achievable for regular savings account.',
  'FilterDescription': 'This audience category contains information about individual’s Financial Services such as credit card holders.',
  'PopUpInfoIconDescription': 'High affinity to banking product ‘Fixed Deposits’. Attracted to the higher rate of interest than achievable for regular savings account.',
  'OneLiner': ''},
 {'ID': 39,
  'Group': 'Financial > Banking',
  'Category': 'Banking: Credit Card Holding',
  'SubCategory': '01: Expected rare / Irregular Use',
  'Description(Facebook)': "High affinity to hold a credit card with expected irregular use, more for 'emergencies' and exxceptional situations.",
  'FilterDescription': 'This audience category contains information about individual’s Financial Services such as credit card holders.',
  'PopUpInfoIconDescription': "High affinity to hold a credit card with expected irregular use, more for 'emergencies' and exxceptional situations.",
  'OneLiner': ''},
 {'ID': 40,
  'Group': 'Financial > Banking',
  'Category': 'Banking: Credit Card Holding',
  'SubCategory': '02: Expected Moderate / Average Use',
  'Description(Facebook)': 'High affinity to hold a credit card with expected moderate use, regularly but not heavy for many payments to be done.',
  'FilterDescription': 'This audience category contains information about individual’s Financial Services such as credit card holders.',
  'PopUpInfoIconDescription': 'High affinity to hold a credit card with expected moderate use, regularly but not heavy for many payments to be done.',
  'OneLiner': ''},
 {'ID': 41,
  'Group': 'Financial > Banking',
  'Category': 'Banking: Credit Card Holding',
  'SubCategory': '03: Expected heavy / Frequent Use',
  'Description(Facebook)': "High affinity to hold a credit card with expected heavy use, regularly and for many payments 'every other day'.",
  'FilterDescription': 'This audience category contains information about individual’s Financial Services such as credit card holders.',
  'PopUpInfoIconDescription': "High affinity to hold a credit card with expected heavy use, regularly and for many payments 'every other day'.",
  'OneLiner': ''},
 {'ID': 42,
  'Group': 'Automobile',
  'Category': '01: Entry Price - Segment INR 4,00,000 - 7,00,000',
  'SubCategory': 'Automobile - 01: Entry Price - Segment INR 4,00,000 - 7,00,000',
  'Description(Facebook)': 'High affinity to buy in the Entry Price Segment INR 4,00,000 - 7,00,000 (Maruti Suzuki Alto K10, Renault Kwid, Tata Tiago, etc).',
  'FilterDescription': 'Consumers who are likely to own varying types of motor vehicles as well as the affinity to buy cars in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Entry Price Segment INR 4,00,000 - 7,00,000 (Maruti Suzuki Alto K10, Renault Kwid, Tata Tiago, etc).',
  'OneLiner': ''},
 {'ID': 43,
  'Group': 'Automobile',
  'Category': ' 02: Entry Premium Hatch Segment INR 6,00,000 - 10,00,000',
  'SubCategory': 'Automobile - 02: Entry Premium Hatch Segment INR 6,00,000 - 10,00,000',
  'Description(Facebook)': 'High affinity to buy in the Entry Premium Hatch Segment INR 6,00,000 - 10,00,000(Maruti Suzuki IGNIS, Maruti Suzuki Swift, Hyundai New Grand i10 NIOS, etc.).',
  'FilterDescription': 'Consumers who are likely to own varying types of motor vehicles as well as the affinity to buy cars in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Entry Premium Hatch Segment INR 6,00,000 - 10,00,000(Maruti Suzuki IGNIS, Maruti Suzuki Swift, Hyundai New Grand i10 NIOS, etc.).',
  'OneLiner': ''},
 {'ID': 44,
  'Group': 'Automobile',
  'Category': '03: Premium Hatch Segment INR 7,00,000 - 11,00,000',
  'SubCategory': 'Automobile - 03: Premium Hatch Segment INR 7,00,000 - 11,00,000',
  'Description(Facebook)': 'High affinity to buy in the Premium Hatch Segment INR 7,00,000 - 11,00,000 (Maruti Suzuki Baleno, Hyundai All New i20, Tata Altroz, etc.). ',
  'FilterDescription': 'Consumers who are likely to own varying types of motor vehicles as well as the affinity to buy cars in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Premium Hatch Segment INR 7,00,000 - 11,00,000 (Maruti Suzuki Baleno, Hyundai All New i20, Tata Altroz, etc.). ',
  'OneLiner': ''},
 {'ID': 45,
  'Group': 'Automobile',
  'Category': '04: Compact Sedan Segment INR 6,00,000 - 10,00,000',
  'SubCategory': 'Automobile - 04: Compact Sedan Segment INR 6,00,000 - 10,00,000',
  'Description(Facebook)': 'High affinity to buy in the Compact Sedan Segment INR 6,00,000 - 10,00,000 (Maruti Suzuki Dzire, Hyundai Aura, Tata Tigor, etc.).',
  'FilterDescription': 'Consumers who are likely to own varying types of motor vehicles as well as the affinity to buy cars in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Compact Sedan Segment INR 6,00,000 - 10,00,000 (Maruti Suzuki Dzire, Hyundai Aura, Tata Tigor, etc.).',
  'OneLiner': ''},
 {'ID': 46,
  'Group': 'Automobile',
  'Category': '05: Sedan Segment INR 10,00,000 - 17,50,000',
  'SubCategory': 'Automobile - 05: Sedan Segment INR 10,00,000 - 17,50,000',
  'Description(Facebook)': 'High affinity to buy in the Sedan Segment INR 10,00,000 - 17,50,000 (Skoda Slavia, Hyundai Verna, etc.).',
  'FilterDescription': 'Consumers who are likely to own varying types of motor vehicles as well as the affinity to buy cars in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Sedan Segment INR 10,00,000 - 17,50,000 (Skoda Slavia, Hyundai Verna, etc.).',
  'OneLiner': ''},
 {'ID': 47,
  'Group': 'Automobile',
  'Category': ' 06: Premium Sedan Segment INR 16,00,000 - 25,00,000',
  'SubCategory': 'Automobile - 06: Premium Sedan Segment INR 16,00,000 - 25,00,000',
  'Description(Facebook)': 'High affinity to buy in the Premium Sedan Segment INR 16,00,000 - 25,00,000 (Honda City e:HEV, Volkswagen Virtus Chrome GT Plus - 1.5L TSI DSG, etc.).',
  'FilterDescription': 'Consumers who are likely to own varying types of motor vehicles as well as the affinity to buy cars in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Premium Sedan Segment INR 16,00,000 - 25,00,000 (Honda City e:HEV, Volkswagen Virtus Chrome GT Plus - 1.5L TSI DSG, etc.).',
  'OneLiner': ''},
 {'ID': 48,
  'Group': 'Automobile',
  'Category': '07: Compact / Entry SUV Segment INR 6,00,000 - 14,00,000',
  'SubCategory': 'Automobile - 07: Compact / Entry SUV Segment INR 6,00,000 - 14,00,000',
  'Description(Facebook)': 'High affinity to buy in the Compact / Entry SUV Segment INR 6,00,000 - 14,00,000 (Hyundai Exter, Tata Punch, Nissan Magnite, etc.).',
  'FilterDescription': 'Consumers who are likely to own varying types of motor vehicles as well as the affinity to buy cars in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Compact / Entry SUV Segment INR 6,00,000 - 14,00,000 (Hyundai Exter, Tata Punch, Nissan Magnite, etc.).',
  'OneLiner': ''},
 {'ID': 49,
  'Group': 'Automobile',
  'Category': '08: SUV Segment INR 20,00,000 – 45,00,000',
  'SubCategory': 'Automobile - 08: SUV Segment INR 20,00,000 – 45,00,000',
  'Description(Facebook)': 'High affinity to buy in the SUV Segment INR 20,00,000 – 45,00,000 (Maruti Suzuki Invicto, Toyota Fortuner, MG Gloster, etc.)',
  'FilterDescription': 'Consumers who are likely to own varying types of motor vehicles as well as the affinity to buy cars in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the SUV Segment INR 20,00,000 – 45,00,000 (Maruti Suzuki Invicto, Toyota Fortuner, MG Gloster, etc.)',
  'OneLiner': ''},
 {'ID': 50,
  'Group': 'Automobile',
  'Category': ' 09: Luxury Premium Sedan & SUV Segment INR 45,00,000+',
  'SubCategory': 'Automobile - 09: Luxury Premium Sedan & SUV Segment INR 45,00,000+',
  'Description(Facebook)': 'High affinity to buy in the Luxury Premium Sedan & SUV Segment INR 45,00,000+ (Mercedes Benz, BMW, Audi).',
  'FilterDescription': 'Consumers who are likely to own varying types of motor vehicles as well as the affinity to buy cars in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Luxury Premium Sedan & SUV Segment INR 45,00,000+ (Mercedes Benz, BMW, Audi).',
  'OneLiner': ''},
 {'ID': 51,
  'Group': 'Real Estate',
  'Category': 'Real Estate - 01: Purchase Price Segment - below INR 50,00,000',
  'SubCategory': 'Real Estate - 01: Purchase Price Segment - below INR 50,00,000',
  'Description(Facebook)': 'High affinity to buy a property in the price range below INR 50,00,000.',
  'FilterDescription': 'This audience category contains information about Home and Property ownership as well as expenditures for it.',
  'PopUpInfoIconDescription': 'High affinity to buy a property in the price range below INR 50,00,000.',
  'OneLiner': ''},
 {'ID': 53,
  'Group': 'Real Estate',
  'Category': 'Real Estate - 02: Purchase Price Segment - INR 51,00,000 - 1 Crore',
  'SubCategory': 'Real Estate - 02: Purchase Price Segment - INR 51,00,000 - 1 Crore',
  'Description(Facebook)': 'High affinity to buy a property in the price range INR 51,00,000 - 1,00,00,000.',
  'FilterDescription': 'This audience category contains information about Home and Property ownership as well as expenditures for it.',
  'PopUpInfoIconDescription': 'High affinity to buy a property in the price range INR 51,00,000 - 1,00,00,000.',
  'OneLiner': ''},
 {'ID': 54,
  'Group': 'Real Estate',
  'Category': 'Real Estate - 03: Purchase Price Segment - INR 1 - 4 Crore',
  'SubCategory': 'Real Estate - 03: Purchase Price Segment - INR 1 - 4 Crore',
  'Description(Facebook)': 'High affinity to buy a property in the price range INR 1 - 4 Crore.',
  'FilterDescription': 'This audience category contains information about Home and Property ownership as well as expenditures for it.',
  'PopUpInfoIconDescription': 'High affinity to buy a property in the price range INR 1 - 4 Crore.',
  'OneLiner': ''},
 {'ID': 55,
  'Group': 'Real Estate',
  'Category': 'Real Estate - 04: Purchase Price Segment - Beyond INR 4 Crore',
  'SubCategory': 'Real Estate - 04: Purchase Price Segment - Beyond INR 4 Crore',
  'Description(Facebook)': 'High affinity to buy a property in the price range beyond INR 4 Crore. ',
  'FilterDescription': 'This audience category contains information about Home and Property ownership as well as expenditures for it.',
  'PopUpInfoIconDescription': 'High affinity to buy a property in the price range beyond INR 4 Crore. ',
  'OneLiner': ''},
 {'ID': 57,
  'Group': 'Laundry',
  'Category': 'Laundry',
  'SubCategory': 'FMCG - Laundry Fabric Wash Products 01: Popular',
  'Description(Facebook)': 'High affinity in the category ‘laundry’ to buy popular fabric wash products: practical, effective, focused on basic performance',
  'FilterDescription': 'Consumers who are likely to purchase goods across various product categories including Food, Personal Wash, Beauty, Home and Living.',
  'PopUpInfoIconDescription': 'High affinity in the category ‘laundry’ to buy popular fabric wash products: practical, effective, focused on basic performance',
  'OneLiner': ''},
 {'ID': 58,
  'Group': 'Laundry',
  'Category': 'Laundry',
  'SubCategory': 'FMCG - Laundry Fabric Wash Products 02: Premium',
  'Description(Facebook)': 'High affinity in the category ‘laundry’ to buy premium fabric wash products. Clean clothes for creating a positive impression and being recognized by society. Special fragrance conscious. (Rin, Sunlight, etc.).',
  'FilterDescription': 'Consumers who are likely to purchase goods across various product categories including Food, Personal Wash, Beauty, Home and Living.',
  'PopUpInfoIconDescription': 'High affinity in the category ‘laundry’ to buy premium fabric wash products. Clean clothes for creating a positive impression and being recognized by society. Special fragrance conscious. (Rin, Sunlight, etc.).',
  'OneLiner': ''},
 {'ID': 60,
  'Group': 'Personal Wash',
  'Category': 'Personal Wash',
  'SubCategory': 'FMCG - Personal Wash 01: Popular',
  'Description(Facebook)': 'High affinity in the category ‘personal wash’ to buy popular classified products Eager to be trendy, getting the “million dollar” feeling (Rexone, Lux, Hamam, Sunsilk, Pepsodent, etc.).',
  'FilterDescription': 'Consumers who are likely to purchase goods across various product categories including Food, Personal Wash, Beauty, Home and Living.',
  'PopUpInfoIconDescription': 'High affinity in the category ‘personal wash’ to buy popular classified products Eager to be trendy, getting the “million dollar” feeling (Rexone, Lux, Hamam, Sunsilk, Pepsodent, etc.).',
  'OneLiner': ''},
 {'ID': 61,
  'Group': 'Personal Wash',
  'Category': 'Personal Wash',
  'SubCategory': 'FMCG - Personal Wash 02: Premium',
  'Description(Facebook)': 'High affinity in the category ‘personal wash’ to buy premium classified products. Health and ingredients conscious, looking for exquisite products (Dove, Ponds, Closeup, Tresemme, etc.).',
  'FilterDescription': 'Consumers who are likely to purchase goods across various product categories including Food, Personal Wash, Beauty, Home and Living.',
  'PopUpInfoIconDescription': 'High affinity in the category ‘personal wash’ to buy premium classified products. Health and ingredients conscious, looking for exquisite products (Dove, Ponds, Closeup, Tresemme, etc.).',
  'OneLiner': ''},
 {'ID': 63,
  'Group': 'Packaged Food',
  'Category': 'Packaged Food',
  'SubCategory': 'FMCG - Packaged Food 01: Popular',
  'Description(Facebook)': 'High affinity in the category ‘packaged food’ to buy popular classified products. Convenience and price conscious, accepting non organic basis. Seeking to be fancy and modern, having quick meals and drinks. ',
  'FilterDescription': 'Consumers who are likely to purchase goods across various product categories including Food, Personal Wash, Beauty, Home and Living.',
  'PopUpInfoIconDescription': 'High affinity in the category ‘packaged food’ to buy popular classified products. Convenience and price conscious, accepting non organic basis. Seeking to be fancy and modern, having quick meals and drinks. ',
  'OneLiner': ''},
 {'ID': 64,
  'Group': 'Packaged Food',
  'Category': 'Packaged Food',
  'SubCategory': 'FMCG - Packaged Food 02: Premium',
  'Description(Facebook)': 'High affinity in the category ‘packaged food’ to buy premium classified products. Seeking high quality, willing to pay higher prices. Associates safety with higher price and being modern. Health driven, searching for natural products. Organic and nutrition conscious. ',
  'FilterDescription': 'Consumers who are likely to purchase goods across various product categories including Food, Personal Wash, Beauty, Home and Living.',
  'PopUpInfoIconDescription': 'High affinity in the category ‘packaged food’ to buy premium classified products. Seeking high quality, willing to pay higher prices. Associates safety with higher price and being modern. Health driven, searching for natural products. Organic and nutrition conscious. ',
  'OneLiner': ''},
 {'ID': 66,
  'Group': 'Cosmetics',
  'Category': 'Cosmetics',
  'SubCategory': 'FMCG - Cosmetics 01: Popular',
  'Description(Facebook)': 'High affinity in the category ‘cosmetics’ to buy popular branded products. Trendy, giving the “million dollar” feeling. ',
  'FilterDescription': 'Consumers who are likely to purchase goods across various product categories including Food, Personal Wash, Beauty, Home and Living.',
  'PopUpInfoIconDescription': 'High affinity in the category ‘cosmetics’ to buy popular branded products. Trendy, giving the “million dollar” feeling. ',
  'OneLiner': ''},
 {'ID': 67,
  'Group': 'Cosmetics',
  'Category': 'Cosmetics',
  'SubCategory': 'FMCG - Cosmetics 02: Premium',
  'Description(Facebook)': 'High affinity in the category ‘cosmetics’ to buy premium classified products. Affinity to luxury. Exquisite, top branded products. ',
  'FilterDescription': 'Consumers who are likely to purchase goods across various product categories including Food, Personal Wash, Beauty, Home and Living.',
  'PopUpInfoIconDescription': 'High affinity in the category ‘cosmetics’ to buy premium classified products. Affinity to luxury. Exquisite, top branded products. ',
  'OneLiner': ''},
 {'ID': 69,
  'Group': 'Fashion & Apparel',
  'Category': 'Purchase Price Category',
  'SubCategory': "Fashion & Apparel - 01: Purchase Price Category 'Medium' (typically INR 800 – 2,000)",
  'Description(Facebook)': 'High affinity to buy clothes and foot ware in the price category "Medium" INR 800 – 2,000. ',
  'FilterDescription': 'Fashion & Apparel',
  'PopUpInfoIconDescription': 'High affinity to buy clothes and foot ware in the price category "Medium" INR 800 – 2,000. ',
  'OneLiner': ''},
 {'ID': 70,
  'Group': 'Fashion & Apparel',
  'Category': 'Purchase Price Category',
  'SubCategory': "Fashion & Apparel - 02: Purchase Price Category 'Premium' (typically INR 2,000 – 3,500)",
  'Description(Facebook)': 'High affinity to buy clothes and foot ware in the price category "Premium" INR 2,000 – 3,500. ',
  'FilterDescription': 'Fashion & Apparel',
  'PopUpInfoIconDescription': 'High affinity to buy clothes and foot ware in the price category "Premium" INR 2,000 – 3,500. ',
  'OneLiner': ''},
 {'ID': 71,
  'Group': 'Fashion & Apparel',
  'Category': 'Purchase Price Category',
  'SubCategory': "Fashion & Apparel - 03: Purchase Price Category 'Super Premium' (typically INR 3,500 – 7,000)",
  'Description(Facebook)': 'High affinity to buy clothes and foot ware in the price category "Super Premium" INR 3,500 – 7,000.',
  'FilterDescription': 'Fashion & Apparel',
  'PopUpInfoIconDescription': 'High affinity to buy clothes and foot ware in the price category "Super Premium" INR 3,500 – 7,000.',
  'OneLiner': ''},
 {'ID': 72,
  'Group': 'Fashion & Apparel',
  'Category': 'Purchase Price Category',
  'SubCategory': "Fashion & Apparel - 04: Purchase Price Category 'Luxury' (typically INR 7,000+)",
  'Description(Facebook)': 'High affinity to buy clothes and foot ware in the price category "Luxury" INR 7,000 +. ',
  'FilterDescription': 'Fashion & Apparel',
  'PopUpInfoIconDescription': 'High affinity to buy clothes and foot ware in the price category "Luxury" INR 7,000 +. ',
  'OneLiner': ''},
 {'ID': 75,
  'Group': 'Jewellery & Gold',
  'Category': 'Category: Gold',
  'SubCategory': 'Jewellery & Gold - 01: Moderately priced Gold Jewellery',
  'Description(Facebook)': 'High Affinity to buying moderately priced gold jewellery. Expecting to look astonishingly beautiful with gold jewellery and wearing gold as lucky omen with blessings of goddesses.',
  'FilterDescription': 'Consumers who are likely to purchase goods across various product categories including Gold and Jewellery.',
  'PopUpInfoIconDescription': 'High Affinity to buying moderately priced gold jewellery. Expecting to look astonishingly beautiful with gold jewellery and wearing gold as lucky omen with blessings of goddesses.',
  'OneLiner': ''},
 {'ID': 76,
  'Group': 'Jewellery & Gold',
  'Category': 'Category: Gold',
  'SubCategory': 'Jewellery & Gold - 02: High priced Gold Jewellery',
  'Description(Facebook)': 'High Affinity to buying high priced gold jewellery. Expecting to look astonishingly beautiful with gold jewellery and wearing gold as lucky omen with blessings of goddesses.',
  'FilterDescription': 'Consumers who are likely to purchase goods across various product categories including Gold and Jewellery.',
  'PopUpInfoIconDescription': 'High Affinity to buying high priced gold jewellery. Expecting to look astonishingly beautiful with gold jewellery and wearing gold as lucky omen with blessings of goddesses.',
  'OneLiner': ''},
 {'ID': 77,
  'Group': 'Jewellery & Gold',
  'Category': 'Category: Diamond',
  'SubCategory': 'Jewellery & Gold - 01: Moderately priced Diamond Jewellery',
  'Description(Facebook)': 'High Affinity to buying moderately priced diamond jewellery. Wearing (branded) diamond jewellery as level of modern exclusivity and luxury.',
  'FilterDescription': 'Consumers who are likely to purchase goods across various product categories including Gold and Jewellery.',
  'PopUpInfoIconDescription': 'High Affinity to buying moderately priced diamond jewellery. Wearing (branded) diamond jewellery as level of modern exclusivity and luxury.',
  'OneLiner': ''},
 {'ID': 78,
  'Group': 'Jewellery & Gold',
  'Category': 'Category: Diamond',
  'SubCategory': 'Jewellery & Gold - 02: High priced Diamond Jewellery',
  'Description(Facebook)': 'High Affinity to buying high priced diamond jewellery. Wearing (branded) diamond jewellery as level of modern exclusivity and luxury.',
  'FilterDescription': 'Consumers who are likely to purchase goods across various product categories including Gold and Jewellery.',
  'PopUpInfoIconDescription': 'High Affinity to buying high priced diamond jewellery. Wearing (branded) diamond jewellery as level of modern exclusivity and luxury.',
  'OneLiner': ''},
 {'ID': 79,
  'Group': 'Travel > Short Term',
  'Category': 'Short Term Holidays',
  'SubCategory': "Travel Short Term - 01: Spend Category 'Basic'",
  'Description(Facebook)': 'High Affinity to go on weekend get-aways, standard quality destinations - appreciating basic amenities.',
  'FilterDescription': 'Consumers who are likely to travel are part of these segments. Information about their travel habits, like destination and spending, is provided.',
  'PopUpInfoIconDescription': 'High Affinity to go on weekend get-aways, standard quality destinations - appreciating basic amenities.',
  'OneLiner': ''},
 {'ID': 80,
  'Group': 'Travel > Short Term',
  'Category': 'Short Term Holidays',
  'SubCategory': "Travel Short Term - 02: Spend Category 'Luxury'",
  'Description(Facebook)': 'High Affinity to go on weekend get-aways, luxury destinations - wellness and high comfort focussed.',
  'FilterDescription': 'Consumers who are likely to travel are part of these segments. Information about their travel habits, like destination and spending, is provided.',
  'PopUpInfoIconDescription': 'High Affinity to go on weekend get-aways, luxury destinations - wellness and high comfort focussed.',
  'OneLiner': ''},
 {'ID': 82,
  'Group': 'Travel > Long Term',
  'Category': 'Long Term Holidays',
  'SubCategory': "Travel Long Term : Destination Category 'International'",
  'Description(Facebook)': 'High Affinity to go on trips longer than 10 days, worldwide destinations inlcuding cruises.',
  'FilterDescription': 'Consumers who are likely to travel are part of these segments. Information about their travel habits, like destination and spending, is provided.',
  'PopUpInfoIconDescription': 'High Affinity to go on trips longer than 10 days, worldwide destinations inlcuding cruises.',
  'OneLiner': ''},
 {'ID': 84,
  'Group': 'Retail',
  'Category': 'High Frequency Online Shopping',
  'SubCategory': 'Retail - Online Shopping 01: Expected rare / Irregular Use',
  'Description(Facebook)': 'Expected irregular online shopping affinity',
  'FilterDescription': 'Retail',
  'PopUpInfoIconDescription': 'Expected irregular online shopping affinity',
  'OneLiner': ''},
 {'ID': 86,
  'Group': 'Retail',
  'Category': 'High Frequency Online Shopping',
  'SubCategory': 'Retail - Online Shopping 02: Expected heavy / Frequent Use',
  'Description(Facebook)': 'Expected expected heavy use online shopping affinity',
  'FilterDescription': 'Retail',
  'PopUpInfoIconDescription': 'Expected expected heavy use online shopping affinity',
  'OneLiner': ''},
 {'ID': 89,
  'Group': 'Two Wheeler',
  'Category': '01: Entry Level Scooter Segment',
  'SubCategory': 'Two Wheeler - 01: Entry Level Scooter Segment',
  'Description(Facebook)': 'High affinity to buy in the Entry Level Scooter Segment',
  'FilterDescription': 'Consumers who are likely to own varying types of Two Wheelers as well as the affinity to buy in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Entry Level Scooter Segment',
  'OneLiner': ''},
 {'ID': 90,
  'Group': 'Two Wheeler',
  'Category': '02: Premium Scooter Segment',
  'SubCategory': 'Two Wheeler - 02: Premium Scooter Segment',
  'Description(Facebook)': 'High affinity to buy in the Premium Scooter Segment',
  'FilterDescription': 'Consumers who are likely to own varying types of Two Wheelers as well as the affinity to buy in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Premium Scooter Segment',
  'OneLiner': ''},
 {'ID': 91,
  'Group': 'Two Wheeler',
  'Category': '03: Entry Level Commuter Segment',
  'SubCategory': 'Two Wheeler - 03: Entry Level Commuter Segment',
  'Description(Facebook)': 'High affinity to buy in the Entry Level Commuter Segment',
  'FilterDescription': 'Consumers who are likely to own varying types of Two Wheelers as well as the affinity to buy in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Entry Level Commuter Segment',
  'OneLiner': ''},
 {'ID': 92,
  'Group': 'Two Wheeler',
  'Category': '04: Premium Commuter Segment',
  'SubCategory': 'Two Wheeler - 04: Premium Commuter Segment',
  'Description(Facebook)': 'High affinity to buy in the Premium Commuter Segment',
  'FilterDescription': 'Consumers who are likely to own varying types of Two Wheelers as well as the affinity to buy in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Premium Commuter Segment',
  'OneLiner': ''},
 {'ID': 93,
  'Group': 'Two Wheeler',
  'Category': '05: Entry Level Sports Bike Segment',
  'SubCategory': 'Two Wheeler - 05: Entry Level Sports Bike Segment',
  'Description(Facebook)': 'High affinity to buy in the Entry Level Sports Bike Segment',
  'FilterDescription': 'Consumers who are likely to own varying types of Two Wheelers as well as the affinity to buy in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Entry Level Sports Bike Segment',
  'OneLiner': ''},
 {'ID': 94,
  'Group': 'Two Wheeler',
  'Category': '06: Premium Sports Bike Segment',
  'SubCategory': 'Two Wheeler - 06: Premium Sports Bike Segment',
  'Description(Facebook)': 'High affinity to buy in the Premium Sports Bike Segment',
  'FilterDescription': 'Consumers who are likely to own varying types of Two Wheelers as well as the affinity to buy in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Premium Sports Bike Segment',
  'OneLiner': ''},
 {'ID': 95,
  'Group': 'Two Wheeler',
  'Category': '07: Entry Level Cruiser Bike Segment',
  'SubCategory': 'Two Wheeler - 07: Entry Level Cruiser Bike Segment',
  'Description(Facebook)': 'High affinity to buy in the Entry Level Cruiser Bike Segment',
  'FilterDescription': 'Consumers who are likely to own varying types of Two Wheelers as well as the affinity to buy in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Entry Level Cruiser Bike Segment',
  'OneLiner': ''},
 {'ID': 96,
  'Group': 'Two Wheeler',
  'Category': '08: Premium Cruiser Bike Segment',
  'SubCategory': 'Two Wheeler - 08: Premium Cruiser Bike Segment',
  'Description(Facebook)': 'High affinity to buy in the Premium Cruiser Bike Segment',
  'FilterDescription': 'Consumers who are likely to own varying types of Two Wheelers as well as the affinity to buy in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Premium Cruiser Bike Segment',
  'OneLiner': ''},
 {'ID': 97,
  'Group': 'Two Wheeler',
  'Category': '09: Touring Bike Segment',
  'SubCategory': 'Two Wheeler - 09: Touring Bike Segment',
  'Description(Facebook)': 'High affinity to buy in the Touring Bike Segment',
  'FilterDescription': 'Consumers who are likely to own varying types of Two Wheelers as well as the affinity to buy in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Touring Bike Segment',
  'OneLiner': ''},
 {'ID': 98,
  'Group': 'Two Wheeler',
  'Category': '10: Off Road Bike Segment',
  'SubCategory': 'Two Wheeler - 10: Off Road Bike Segment',
  'Description(Facebook)': 'High affinity to buy in the Off Road Bike Segment',
  'FilterDescription': 'Consumers who are likely to own varying types of Two Wheelers as well as the affinity to buy in a specific price range.',
  'PopUpInfoIconDescription': 'High affinity to buy in the Off Road Bike Segment',
  'OneLiner': ''},
 {'ID': 99,
  'Group': 'Electronics Segmentation',
  'Category': 'TV',
  'SubCategory': 'Electronic Consumer Goods - TV 01: Premium',
  'Description(Facebook)': 'Consumers in this category generally own high-end, feature-rich TVs with the latest technologies (e.g., 4K, OLED, QLED, Smart TVs with voice assistants, etc.).Focus on superior viewing experiences, including premium content like OTT subscriptions (Netflix, Amazon Prime, Disney+ Hotstar, etc.).',
  'FilterDescription': 'Electronics Segmentation',
  'PopUpInfoIconDescription': 'Consumers in this category generally own high-end, feature-rich TVs with the latest technologies (e.g., 4K, OLED, QLED, Smart TVs with voice assistants, etc.).Focus on superior viewing experiences, including premium content like OTT subscriptions (Netflix, Amazon Prime, Disney+ Hotstar, etc.).',
  'OneLiner': ''},
 {'ID': 100,
  'Group': 'Electronics Segmentation',
  'Category': 'TV',
  'SubCategory': 'Electronic Consumer Goods  - TV 02: Popular',
  'Description(Facebook)': 'Consumers in this category typically opt for mid-range TVs that offer a good balance of quality and affordability. These TVs might include LED, LCD, and Smart TVs that are not necessarily the top-end models but still have a decent set of features.',
  'FilterDescription': 'Electronics Segmentation',
  'PopUpInfoIconDescription': 'Consumers in this category typically opt for mid-range TVs that offer a good balance of quality and affordability. These TVs might include LED, LCD, and Smart TVs that are not necessarily the top-end models but still have a decent set of features.',
  'OneLiner': ''},
 {'ID': 102,
  'Group': 'Electronics Segmentation',
  'Category': 'Smartphone',
  'SubCategory': 'Electronic Consumer Goods - Smartphone 01: Premium',
  'Description(Facebook)': 'Consumers in this category opt for high-end, flagship smartphones with the latest technology, features, and premium build quality. They also tend to spend more on accessories and services such as extended warranties, premium apps, and app subscriptions.',
  'FilterDescription': 'Electronics Segmentation',
  'PopUpInfoIconDescription': 'Consumers in this category opt for high-end, flagship smartphones with the latest technology, features, and premium build quality. They also tend to spend more on accessories and services such as extended warranties, premium apps, and app subscriptions.',
  'OneLiner': ''},
 {'ID': 103,
  'Group': 'Electronics Segmentation',
  'Category': 'Smartphone',
  'SubCategory': 'Electronic Consumer Goods - Smartphone 02: Popular',
  'Description(Facebook)': 'The popular category includes mid-range smartphones that offer a balance of good performance and affordability.',
  'FilterDescription': 'Electronics Segmentation',
  'PopUpInfoIconDescription': 'The popular category includes mid-range smartphones that offer a balance of good performance and affordability.',
  'OneLiner': ''},
 {'ID': 105,
  'Group': 'Electronics Segmentation',
  'Category': 'Refrigerator',
  'SubCategory': 'Electronic Consumer Goods - Refrigerator 01: Premium',
  'Description(Facebook)': 'Consumers in this category opt for high-end refrigerators with advanced features and superior build quality. Often come with features such as frost-free technology, multi-door designs, French door fridges, smart technology (Wi-Fi connectivity), energy-efficient ratings, advanced cooling systems, touchscreen controls, and customizable temperature zones.',
  'FilterDescription': 'Electronics Segmentation',
  'PopUpInfoIconDescription': 'Consumers in this category opt for high-end refrigerators with advanced features and superior build quality. Often come with features such as frost-free technology, multi-door designs, French door fridges, smart technology (Wi-Fi connectivity), energy-efficient ratings, advanced cooling systems, touchscreen controls, and customizable temperature zones.',
  'OneLiner': ''},
 {'ID': 106,
  'Group': 'Electronics Segmentation',
  'Category': 'Refrigerator',
  'SubCategory': 'Electronic Consumer Goods - Refrigerator 02: Popular',
  'Description(Facebook)': 'Consumers in this category look for reliable and efficient refrigerators that balance performance and affordability.\nPopular refrigerators come with essential features such as frost-free technology, multiple compartments, reliable cooling, adjustable shelves, and good energy ratings but lack the advanced smart features or luxury designs of premium models.',
  'FilterDescription': 'Electronics Segmentation',
  'PopUpInfoIconDescription': 'Consumers in this category look for reliable and efficient refrigerators that balance performance and affordability.\nPopular refrigerators come with essential features such as frost-free technology, multiple compartments, reliable cooling, adjustable shelves, and good energy ratings but lack the advanced smart features or luxury designs of premium models.',
  'OneLiner': ''},
 {'ID': 108,
  'Group': 'Electronics Segmentation',
  'Category': 'Washing Machine',
  'SubCategory': 'Electronic Consumer Goods - Washing Machine 01: Premium',
  'Description(Facebook)': 'Consumers in this category opt for high-end washing machines that come with advanced features, superior build quality, and enhanced performance.Premium models include front-load and top-load machines with features such as smart technology (Wi-Fi connectivity), steam cleaning, advanced wash programs, inverter motors, large drum capacity, smart sensors, and eco-friendly wash cycles.',
  'FilterDescription': 'Electronics Segmentation',
  'PopUpInfoIconDescription': 'Consumers in this category opt for high-end washing machines that come with advanced features, superior build quality, and enhanced performance.Premium models include front-load and top-load machines with features such as smart technology (Wi-Fi connectivity), steam cleaning, advanced wash programs, inverter motors, large drum capacity, smart sensors, and eco-friendly wash cycles.',
  'OneLiner': ''},
 {'ID': 109,
  'Group': 'Electronics Segmentation',
  'Category': 'Washing Machine',
  'SubCategory': 'Electronic Consumer Goods - Washing Machine 02: Popular',
  'Description(Facebook)': 'The popular category includes mid-range washing machines that offer a balance of performance and affordability.Popular washing machines often feature top-load designs, semi-automatic or fully automatic models, and offer useful features like multiple wash programs, efficient spin cycles, larger capacities (6-8 kg), and decent energy efficiency.',
  'FilterDescription': 'Electronics Segmentation',
  'PopUpInfoIconDescription': 'The popular category includes mid-range washing machines that offer a balance of performance and affordability.Popular washing machines often feature top-load designs, semi-automatic or fully automatic models, and offer useful features like multiple wash programs, efficient spin cycles, larger capacities (6-8 kg), and decent energy efficiency.',
  'OneLiner': ''},
 {'ID': 111,
  'Group': 'Electronics Segmentation',
  'Category': 'Air Conditioner',
  'SubCategory': 'Electronic Consumer Goods - Air Conditioner 01: Premium',
  'Description(Facebook)': 'Premium ACs feature advanced technologies and superior build quality, designed for luxury and high performance.\nThese ACs include inverter technology, smart features (Wi-Fi connectivity), energy-efficient compressors, air purifiers, multi-stage filtration, advanced cooling systems, and quieter operations.',
  'FilterDescription': 'Electronics Segmentation',
  'PopUpInfoIconDescription': 'Premium ACs feature advanced technologies and superior build quality, designed for luxury and high performance.\nThese ACs include inverter technology, smart features (Wi-Fi connectivity), energy-efficient compressors, air purifiers, multi-stage filtration, advanced cooling systems, and quieter operations.',
  'OneLiner': ''},
 {'ID': 112,
  'Group': 'Electronics Segmentation',
  'Category': 'Air Conditioner',
  'SubCategory': 'Electronic Consumer Goods - Air Conditioner 02: Popular',
  'Description(Facebook)': 'Popular ACs strike a balance between performance and affordability, featuring energy-efficient inverter technology, auto-cleaning features, and multiple cooling modes.\nThese ACs typically include split units, window units, and multi-split systems, offering a variety of capacities and cooling features.',
  'FilterDescription': 'Electronics Segmentation',
  'PopUpInfoIconDescription': 'Popular ACs strike a balance between performance and affordability, featuring energy-efficient inverter technology, auto-cleaning features, and multiple cooling modes.\nThese ACs typically include split units, window units, and multi-split systems, offering a variety of capacities and cooling features.',
  'OneLiner': ''}]